//mui
import Tooltip from '@mui/material/Tooltip';

const CustomToolTip = ( {children, ...props}) => {
  return (
    <Tooltip
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomToolTip;